import { sortRouteServiceStatusTypeByPriority } from './sortSailingStatusByPriority';

export const sortRouteSailingStatusByStartDate = (a, b) => {
  if (!a.startDate || !b.startDate) {
    return 0;
  }
  if (a.startDate < b.startDate) {
    return -1;
  }
  if (a.startDate > b.startDate) {
    return 1;
  }
  if (a.startDate === b.startDate) {
    return sortRouteServiceStatusTypeByPriority(a, b);
  }
  return 0;
};
